module.exports = __webpack_public_path__ + "735532b5fc64a7ba4a7787bd30c0fcd2.mov";